<template>
    <div class="bgFoto">
        <div class="row justify-content-center einblenden1">
          <div class="col-md-8 text-center headline py-5">
            <h1 class="headline">Komplettlösungen für Ihren Innenausbau</h1>
          </div>
        </div>
        <div class="row justify-content-center einblenden2 py-5">
          <div class="col-md-8 text-center headlineB">
            <h1 class="headlineB">Fliesenverlegung - Trockenbau</h1>
          </div>
        </div>
        <div class="row justify-content-center einblenden3 py-5">
          <div class="col-md-8 text-center headlineB">
            <h1 class="headlineB">Qualifizierter Türenfachbetrieb</h1>
          </div>
        </div>
        <div class="row justify-content-center  mb-5">
          <!-- <div class="col-md-8 text-center">
            <p class="headline2 rundeEcken p-4 text-center">
              Vertrauen Sie auf unser Know-how von der Planung bis zur Umsetzung.
            </p>
          </div> -->
          <div class="col-md-7 DES handyansicht">
            <h2>Montage von leichten Trennwänden</h2>
            <h2>Design-Decken und Wände</h2>
            <h2>Brandschutzverkleidung</h2>
            <h2>Raumgestaltung</h2>
            <h2>Dachausbau</h2>
            <h2>Fußböden</h2>
            <h2>Badsanierung</h2>
          </div>
        </div>
      </div>
</template>